import { render, staticRenderFns } from "./wxEnterprises.vue?vue&type=template&id=08c1eb68&scoped=true"
import script from "./wxEnterprises.vue?vue&type=script&lang=js"
export * from "./wxEnterprises.vue?vue&type=script&lang=js"
import style0 from "./wxEnterprises.vue?vue&type=style&index=0&id=08c1eb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1eb68",
  null
  
)

export default component.exports